export default class SliderScrolling {
    static getScrollCondition(container, scrollPixels) {
        const scrollPos = container.scrollLeft;

        // Condition to check if scrolling is required
        return !((scrollPos === 0 || scrollPixels > 0) && (container.clientWidth + scrollPos === container.scrollWidth || scrollPixels < 0))
    }

    /**
     * Horizontal scrolling.
     * @param container: the container which is horizontally scrolled
     * @param control: active slider control button
     * @param scrollPixels: the destination which is scrolled
     * @param duration: duration of animated scrolling (ms)
     */
    static scrollingByButtons(container, control, scrollPixels, duration) {
        const scrollPos = container.scrollLeft;
        const prevHiddenControl = container.parentNode.querySelector(this.controlSelector + '.hidden')
        
        if (SliderScrolling.getScrollCondition(container, scrollPixels)) {
            // remove other control hidden class
            prevHiddenControl && prevHiddenControl.classList.remove('hidden')

            // Get the start timestamp
            const startTime =
            "now" in window.performance
            ? performance.now()
            : new Date().getTime();
            
            function scroll(timestamp) {
                //Calculate the timeelapsed
                const timeElapsed = timestamp - startTime;
                //Calculate progress
                const progress = Math.min(timeElapsed / duration, 1);
                //Set the scrolleft
                container.scrollLeft = scrollPos + scrollPixels * progress;
                //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
                if (timeElapsed < duration) {
                    //Request for animation
                    window.requestAnimationFrame(scroll);
                    
                } else {
                    // when end has been reached, hide control
                    if (!SliderScrolling.getScrollCondition(container, scrollPixels)) control.classList.add('hidden');

                    return;
                }
            }
            
            //Call requestAnimationFrame on scroll function first time
            window.requestAnimationFrame(scroll);
        }
    }

    /**
     * Define vars necessary for other "simulate scroll" fns.
     */
    static simulateScrollRecalculate() {
        window.lastScroll = window.pageYOffset;
        // get horizontally scrolled els
        window.verticallyScrolledEls = document.getElementsByClassName('js-vertically-scrolled')[0];

        if (window.verticallyScrolledEls) {
            // define element's properties
            window.elScrolledWidth = window.verticallyScrolledEls.scrollWidth - window.verticallyScrolledEls.offsetWidth;
            window.elHeight = this.outerHeight(window.verticallyScrolledEls);
            window.elTopPosition = window.verticallyScrolledEls.getBoundingClientRect().top - ((window.innerHeight / 2) - (window.elHeight / 2));
        } else {
            // set that scrolled el doesn't exist
            window.verticallyScrolledEls = false;
        }
    }

    /**
     * Bind on scroll event. Work only on devices 800px and wider && on pages with horizontally scrolled els.
     */
    static simulateScroll() {
        if (window.matchMedia('(min-width:800px)').matches && window.verticallyScrolledEls) {
            let prevVerticalHeight = 0, theNum = 0, scrollTop = window.pageYOffset;

            // when user is below the scrolled element increase prevVerticalHeight to compensate scrolled width of element
            if (window.elTopPosition < window.pageYOffset && window.verticallyScrolledEls !== false) prevVerticalHeight = elScrolledWidth;
            //  when user reach the scrolled element
            if (window.elTopPosition < window.pageYOffset &&
                window.elTopPosition + window.elScrolledWidth > window.pageYOffset &&
                window.verticallyScrolledEls !== false) {
                theNum = -window.elTopPosition;
                // fix position
                window.appContainer.style.top = `-${theNum}px`;
                // and scroll with element
                // scrollY - window.elTopPosition = scrolled width
                // when scrolled width is 0 or at the end this condition is false
                window.verticallyScrolledEls.scrollLeft = window.pageYOffset - window.elTopPosition;
            } else {
                theNum = -scrollTop + prevVerticalHeight;
                // continue in scrolling
                window.appContainer.style.top = `${theNum}px`;
            }
            window.lastScroll = scrollTop;
        } else {
            if (window.appContainer) window.appContainer.style.top = '0px';
        }
    }

    static outerHeight(el) {
        let height = el.offsetHeight;
        const style = getComputedStyle(el);
        height += parseInt(style.marginTop) + parseInt(style.marginBottom);
        return height;
    }

    static init() {
        const sliderContainerList = document.querySelectorAll('.slider');
        this.controlSelector = '.slider__control'

        sliderContainerList.forEach(sliderContainer => {
            const sliderWrapper = sliderContainer.querySelector('.slider__inner');
            const itemWidth = sliderWrapper.children[1].getBoundingClientRect().width;
            const sliderControls = sliderContainer.querySelectorAll(this.controlSelector);
            const hasScrollBar = sliderWrapper.scrollWidth > sliderWrapper.clientWidth;
            SliderScrolling.simulateScrollRecalculate();
            SliderScrolling.simulateScroll();
            SliderScrolling.outerHeight(sliderContainer);

            console.log(sliderContainer, sliderWrapper.scrollWidth, sliderWrapper.clientWidth );

            sliderControls.forEach((control, i) => {
                const scroll = !i ? -itemWidth : itemWidth
                console.log(control, !i, itemWidth)

                if (hasScrollBar && i === 1) {
                    control.classList.remove('hidden')
                } else {
                    control.classList.add('hidden')
                }

                control.addEventListener('click', e => {
                    SliderScrolling.scrollingByButtons(sliderWrapper, e.target.closest(this.controlSelector), scroll, 250)
                })
            })

            sliderWrapper.addEventListener('scroll', () => {
                for (let i = 0; i <= 1; i++) {
                    const scroll = !i ? -itemWidth : itemWidth

                    if (SliderScrolling.getScrollCondition(sliderWrapper, scroll)) {
                        sliderControls[i].classList.remove('hidden');
                    } else {
                        sliderControls[i].classList.add('hidden');
                    }
                }
            })
        })
    }
}